export var positions = [[-1, 1, 0], [1, -1, 0], [-1, -1, 0], [-1, 1, 0], [1, 1, 0], [1, -1, 0]];